export default __webpack_public_path__ + "static/media/batting_practice.4376134c.png";